"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { canAnimatePointer, loadGsap, shouldReduceMotion } from "@/lib/gsap";
export function useFaqAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const gsap = await loadGsap();
        if (cancelled || !sectionRef.current) {
          return;
        }
        const section = sectionRef.current;
        const ctx = gsap.context(() => {
          const enableHover = canAnimatePointer();
          const visibleContainer = Array.from(section.querySelectorAll(".faq-animate-trigger")).find(_temp);
          if (!visibleContainer) {
            return;
          }
          const copy = visibleContainer.querySelector(".faq-copy");
          const items = Array.from(visibleContainer.querySelectorAll(".faq-item"));
          const revealTargets = [copy, ...items].filter(_temp2);
          gsap.set(revealTargets, {
            opacity: 0,
            y: 24
          });
          const reveal = () => {
            gsap.to(revealTargets, {
              opacity: 1,
              y: 0,
              duration: 0.7,
              ease: "power3.out",
              stagger: 0.08
            });
          };
          const observer = new IntersectionObserver(t2 => {
            const [entry] = t2;
            if (!entry?.isIntersecting) {
              return;
            }
            reveal();
            observer.disconnect();
          }, {
            threshold: 0.25,
            rootMargin: "0px 0px -10% 0px"
          });
          observer.observe(visibleContainer);
          items.forEach(item => {
            const enter = () => {
              if (!enableHover) {
                return;
              }
              gsap.to(item, {
                duration: 0.38,
                ease: "power3.out"
              });
            };
            const leave = () => {
              if (!enableHover) {
                return;
              }
              gsap.to(item, {
                duration: 0.28,
                ease: "power3.out"
              });
            };
            item.addEventListener("mouseenter", enter);
            item.addEventListener("mouseleave", leave);
            item.addEventListener("focusin", enter);
            item.addEventListener("focusout", leave);
          });
          cleanup = () => {
            observer.disconnect();
            ctx.revert();
          };
        }, section);
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
function _temp2(target) {
  return target !== null;
}
function _temp(container) {
  return container.offsetParent !== null;
}